import React from "react";
import "./Marker.scss";
import Avatar from "@material-ui/core/Avatar";
import ToolTip from "@material-ui/core/Tooltip";
import { getFormattedImageLink } from "Utils";
import { getUserFormattedTimeFromAPIData } from "Utils/dates";

const Marker = (props: any) => {
  const { imagepath, punchtime } = props;
  return (
    <ToolTip title={getUserFormattedTimeFromAPIData(punchtime)} placement="top">
      <div className="marker" style={{ cursor: "pointer" }}>
        <img
          src={getFormattedImageLink(imagepath)}
          style={{ borderRadius: 32, border: "1px solid #1E8CED" }}
          height="32"
        ></img>
      </div>
    </ToolTip>
  );
};

export default Marker;
